import { render, staticRenderFns } from "./inventory-item.svg.vue?vue&type=template&id=11e48b39&"
import script from "./inventory-item.svg.vue?vue&type=script&lang=js&"
export * from "./inventory-item.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports